import { Button, Table } from 'reactstrap';
import React, { useState } from 'react'
import MinimizableContainer from './MinimizableContainer';
import DocumentModal from './DocumentModal';
import { useDispatch, useSelector } from 'react-redux';
// import ResearchKeyDropdown from './ResearchKeyDropdown';
import { useParams } from "react-router-dom"
// import {useQuery} from "react-query";
// import getDocumentsValidated from '../../../api/getDocumentsValidated';
import deleteDocument from '../../../api/deleteDocument';
import { Modal, ModalHeader } from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import { BiDownload } from 'react-icons/bi';
import getDefaultDocument from '../../../api/getDefaultDocument';
import { showToastAction } from '../../../redux/toastSlice';
import URLS from '../../../utils/URLS';

const ResearchedDocumentModal = ({ documents, showResearch, handleCloseResearch, documentsStatus }) => {
    const selectedProject = useSelector(state => state.selectedProject);
    const userState = useSelector(state => state.user)
    const { form_name } = useParams();
    // const {isLoading, data: documents, refetch} = useQuery("getDocumentsValidated" + selectedProject.name + form_name,() => getDocumentsValidated(selectedProject.name, form_name))
    const dispatch = useDispatch()
    // const [minimized, setMinimized] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const preferences = useSelector(state => state.preferences);
    const preferencesArray = Object.entries(preferences)
    const filteredPreferences = preferencesArray.filter((el) => el[1] === true);
    const isAccessUser = (userState.user_type === 'CAPTURE' || userState.user_type === 'ADMIN' || userState.user_type === 'MASTER')

    const handleClose = () => setShowModal(false);
    const handleShow = (document) => {
        setSelectedDocument(document)
        setShowModal(true);
    }

    const handleDeleteDocument = async (id) => {
        try {
            await deleteDocument(selectedProject.name, form_name, id)
            dispatch(showToastAction({ message: "Success", showToast: true, severity: "success" }))
            refetch();
        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    // if(isLoading) return <></>;

    if (!documents) return <></>

    const SmartText = ({ text, length = 20 }) => {
        const [showLess, setShowLess] = React.useState(true);

        if (text.length < length) {
            return <div>{text}</div>;
        }

        return (
            <div>
                {showLess ? text.slice(0, length) : text}
                {showLess ? <a className="read-or-hide" onMouseOver={() => setShowLess(!showLess)}
                >....</a> : <a className="read-or-hide" onMouseOver={() => setShowLess(true)}
                >...less</a>}
            </div>
        );
    };

    const handleDownloadDoc = (id) => {
        getDefaultDocument(selectedProject.name, form_name, id).then((res) => {
            let type = res.data.type.split("/")
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `document.${type.at(-1)}`); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
    }

    const handleExcelDownload = () => {
        if (documents.at(-1) !== undefined) {
            let url = `${URLS.EXCEL_DOWNLOAD_URL}` + documents.at(-1);
            window.location.href = url
        }
    }

    const documentsColumns = [
        ...filteredPreferences.map((([key]) => {
            return {
                dataField: key,
                text: key,
                formatter: (data) => formatterColumn(data)
            }
        })),
        {
            dataField: 'd',
            text: 'Actions',
            headerAlign: 'center',
            formatter: (data, val, rowIndex) => {
                return <div className="d-flex" style={{
                    justifyContent: "flex-end", width: 100,
                    maxWidth: '160',
                    minWidth: 'fit-content',
                    marginLeft: 'auto'
                }}>
                    <button
                        disabled={!isAccessUser}
                        onClick={() => handleShow(val)}
                        className="edit-btn"
                        title={isAccessUser ? "Edit" : "No access"}
                    >
                        <i className="ti-pencil-alt"></i>
                    </button>
                    <button className='edit-btn download-btn' title='download' onClick={() => handleDownloadDoc(val._id)}><BiDownload fontSize={24} /></button>

                    <button className="remove-btn" title="delete" onClick={() => handleDeleteDocument(val._id)}><i className="ti-trash"></i></button>
                </div>
            },
            style: (cell, row, rowIndex, colIndex) => {
                return {
                    width: 50,
                }
            }
        },
    ];

    const formatterColumn = (data) => {
        return data ? <SmartText text={data} /> : '-'
    }

    return (
        <Modal centered className="form-documents modal-big" isOpen={showResearch} toggle={handleCloseResearch} fullscreen={true} size="xl">
            <ModalHeader toggle={handleCloseResearch}>
                Researched documents
                <Button size="sm" style={{ margin: '7px 12px' }} onClick={() => handleExcelDownload()}>
                    <i className="ti-download"></i>
                </Button>
            </ModalHeader>
            {/* <MinimizableContainer className="form-documents" Title={Title} minimized={false}> */}
            <DocumentModal
                selectedDocument={selectedDocument}
                show={showModal}
                handleClose={handleClose}
                document_status={documentsStatus}
            />

            <div className="relative m-3 table_box table_fix" style={{ height: "70vh" }}>
                {documents?.length !== 0 &&
                    <BootstrapTable
                        keyField='_id'
                        data={documents.length >= 0 ? documents.at(0) : []}
                        columns={documentsColumns}
                        hover
                        headerClasses="header-class header-model"
                    />
                }
            </div>
            {/* <div className="max-h-96 relative new-table-resposive">
                    <Table>
                        <thead>
                            <tr>
                                {filteredPreferences.map(([pref]) => <th>{pref.toUpperCase()}</th>)}
                                <th className="text-center">ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents.map((val) => {   
                                const values = Object.entries(val);
                                const filteredValues = values.filter((val) => preferences[val[0]]);
                                return <tr>
                                    {filteredValues.map(([_, value]) => <td><SmartText text={value} /></td>)}
                                    <td className="text-center">
                                        <button onClick={() => handleShow(val)} className="edit-btn" title="edit"><i className="ti-pencil-alt"></i></button>
                                        <button className="remove-btn" title="delete" onClick={() => handleDeleteDocument(val._id)}><i className="ti-trash"></i></button>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                </div>     */}
            {/* </MinimizableContainer> */}
        </Modal>
    )
}



function Title() {
    return <h3 style={{ marginBottom: 0 }} className="heading">Documents <span>(Validated)</span></h3>
}

export default ResearchedDocumentModal
